import Loadable from '~/components/LoadableErrorReload';

// Lazy load the Cognito forgot password page
const ForgotPassword = Loadable(() => import('~/pages/auth/forgot-password/ForgotPassword'));

/**
 * Route component for the forgot password page (/forgot-password).
 *
 * Renders the forgot password flow where users can request a password reset link.
 * Uses Cognito authentication with email verification.
 *
 * @example
 * <ForgotPasswordRoute />
 *
 * @see ForgotPassword (pages/auth/forgot-password/ForgotPassword)
 */
const ForgotPasswordRoute = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordRoute;
